export default "__VITE_PUBLIC_ASSET__44e0bb96__"